const logotext = "ROCKSTAR";
const meta = {
    title: "ROCKSTAR",
    description: "I’m John Doe data scientist _ Full stack devloper,currently working in Berlin",
};

const introdata = {
    title: "I’m Danila Stariy",
    animated: {
        first: "I am a Laravel developer",
        second: "I am a React Js developer",
        third: "I am a Vue Js developer",
    },
    description: "I am an award-winning full-stack web developer and UI/UX javascript specialist. Check out my articles, React and React Native UI components at the code laboratory. Feel free to take a look at my latest projects on the web portfolio page.",
    your_img_url: "./images/my_photo.jpg",
};

const dataabout = {
    title: "Main Skill",
    skill_1: "✔ PHP, MVC(Laravel, CodeIgnight, cakePHP), CMS(Wordpress, Shopify)",
    skill_2: "✔ Javascript/ES6/Typescript: NodeJS, Express, MERN stack, ReactJS, Laravel-VueJS",
    skill_3: "✔ Webpack, Bower, Grunt, Gulp, Elixir, Pip, Composer",
    skill_4: "✔ MySQL, PostgreSQL, Oracle, MongoDB, Firebase, Redis, Couchbase",
    skill_5: "✔ AWS, Heroku, Digital Ocean",
    skill_6: "✔ Payment Gateway Integration (Stripe, Paypal, Braintree and etc)",
    skill_7: "✔ Webpack, Bower, Grunt, Gulp, Elixir, Pip, Composer",
    skill_8: "✔ Webpack, Bower, Grunt, Gulp, Elixir, Pip, Composer",
};
const workflow = {
    flow_1: "✔ Agile, Kanban, Scrum",
    flow_2: "✔ GIT, SVN (bitbucket/github/gitlab)",
    flow_3: "✔ Jira, Trello, Asana, Assembla, Basecamp, ProjectPlace, etc",
};
const worktimeline = [{
        jobtitle: "Designer of week",
        where: "YAdfi",
        date: "2020",
    },
    {
        jobtitle: "Designer of week",
        where: "Jamalya",
        date: "2019",
    },
    {
        jobtitle: "Designer of week",
        where: "ALquds",
        date: "2019",
    },
];

const skills = [{
        name: "Laravel",
        value: 90,
    },
    {
        name: "React",
        value: 85,
    },
    {
        name: "Vue",
        value: 80,
    },
    {
        name: "Angular Js",
        value: 80,
    },
    {
        name: "D3",
        value: 80,
    },
    {
        name: "Wordpress",
        value: 85,
    },
    {
        name: "Shopify",
        value: 85,
    },
];

const services = [{
        title: "Server Side",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
    },
    {
        title: "Front end",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
    },
    {
        title: "Wordpress Design",
        description: "Wordpress CMS is a user-friendly administrative area allowing you to easily edit your website's content. We offer customised WordPress training to ensure you are confident in updating and maintaining your WordPress website.",
    },
];

const dataportfolio = [{
        img: "./images/react/1.png",
        title: "Yu-Gi-Oh Admin Dashboard",
        skills: "React.JS, Redux, Materail UI, Bootstrap, Express.js, MySQL, SendGrid",
        desctiption: "Dashboard, Portal",
        link: "https://admin.ygolegacy.com/",
    },
    {
        img: "./images/react/2.png",
        title: "Yu-Gi-Oh Legacy 1.0",
        skills: "React.JS, Redux, React Hook, Express.js, MySQL, Payment Integration (PayPal), Nginx, VPS, ManyChat",
        desctiption: "E-Commerce",
        link: "https://www.ygolegacy.com/",
    },
    {
        img: "./images/react/3.png",
        title: "Yu-Gi-Oh Trader",
        skills: "Bootstrap, CSS, JQuery, RESTfull API, Chat using Socket.io",
        desctiption: "E-Commerce",
        link: "https://www.ygolegacy.com/",
    },
    {
        img: "./images/react/4.png",
        title: "Video Analysis Player",
        skills: "React.JS, Redux, Hook, Konva.js, Record Canvas using WebRTC, VideoPlayer, Drag and Drop",
        desctiption: "Web APP",
        link: "#",
    },
    {
        img: "./images/react/5.png",
        title: "MERN: Dental Invetory",
        skills: "React.JS, Redux, Hook, Konva.js, Record Canvas using WebRTC, VideoPlayer, Drag and Drop",
        desctiption: "Dashboard, Portal",
        link: "#",
    },
    {
        img: "./images/react/6.png",
        title: "Dental Concierge",
        skills: "React.JS, Redux, Hook, MaterialUI, Chat using Firebase realtime database, Express.js, RESTfull API, MongoDB",
        desctiption: "Dashboard, Portal",
        link: "https://d4wbackup.com/",
    },
    {
        img: "./images/react/7.png",
        title: "AWS S3 Manager",
        skills: "AWS S3, React.JS, MaterialUI, Node.js, MySQL, NGINX, VPS",
        desctiption: "Dashboard, Portal",
        link: "http://tester.oneconnxt.com/",
    },
    {
        img: "./images/react/8.png",
        title: "Get Parking lots API",
        skills: "AWS Lambda, API GateWay, DynamoDB, Node.js",
        desctiption: "Backend API",
        link: "https://d4wbackup.com/",
    },
    {
        img: "./images/react/9.png",
        title: "CloudBackup Manager",
        skills: "React.JS, Firebase, RESTfull API, Socket.io, Sever communication, C#, .NET Framework, Scheduler Service",
        desctiption: "Backend API",
        link: "https://www.sydneybackups.com.au/download/",
    },
    {
        img: "./images/react/10.png",
        title: "GetPhotos",
        skills: "React.JS, Redux, Hook, RESTfull API",
        desctiption: "Web APP",
        link: "https://getphotos.now.sh/",
    },
    {
        img: "./images/react/10.png",
        title: "JWT Authentication",
        skills: "React.JS, Hook, MaterialUI, Express.js, Node.js, MongoDB",
        desctiption: "Web APP",
        link: "https://reactauthen.herokuapp.com/",
    },
    {
        img: "./images/react/11.png",
        title: "OzBackups_Dental4Windows",
        skills: "C#, WPF, MaterialUI, Windows Service(Topshelf package), Schedule(Quartz package), SFTP Upload(SSH.NET package), AWS S3, AWS SFTP",
        desctiption: "DeskTop APP",
        link: "https://d4wbackup.com/",
    },
    {
        img: "./images/react/12.png",
        title: "Studenten bilden Schüler",
        skills: "React.JS, Hook, MaterialUI, Express.js, Node.js, MongoDB",
        desctiption: "Landing Page",
        link: "https://studenten-bilden-schueler.de/",
    },
    {
        img: "./images/react/13.png",
        title: "Ocean artUp",
        skills: "React.JS, Hook, MaterialUI, Express.js, Node.js, MongoDB",
        desctiption: "Landing Page",
        link: "https://ocean-artup.eu/",
    },
];

const contactConfig = {
    YOUR_EMAIL: "vadim.progdev@gmail.com",
    YOUR_SKYPE: "live:.cid.f2be4f4ecaa7cf73",
    description: "If you wanna get in touch, talk to me about a project collaboration or just say hi, fill up the awesome form below or send an email to vadim.progdev@gmail.com and ~let's talk.",
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    github: "https://github.com",
    facebook: "https://facebook.com",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com",
};
export {
    meta,
    dataabout,
    workflow,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};